// STATUS: draft — needs native-speaker check before live
// Polish visitor messages (task TR1, docs/modules/languages.md s2). Visitor keys only; missing keys fall back to en-GB.
export const plVisitor = {
    'kiosk.pairing.title': 'Konfiguracja kiosku',
    'kiosk.pairing.hint': 'Wpisz kod z portalu CloudSign.',
    'kiosk.pairing.go': 'Połącz',
    'kiosk.pairing.codeLabel': 'Kod parowania',
    'kiosk.pairing.checking': 'Sprawdzanie kodu…',
    'kiosk.pairing.clear': 'Wyczyść',
    'kiosk.pairing.back': 'Usuń ostatnią cyfrę',
    'kiosk.pairing.invalid': 'Ten kod jest nieprawidłowy lub wygasł. Poproś o nowy.',
    'kiosk.pairing.noNetwork': 'Nie można połączyć się z CloudSign. Sprawdź Wi-Fi i spróbuj ponownie.',
    'kiosk.common.back': 'Wstecz',
    'kiosk.common.next': 'Dalej',
    'kiosk.common.continue': 'Kontynuuj',
    'kiosk.common.cancel': 'Anuluj',
    'kiosk.common.yes': 'Tak',
    'kiosk.common.no': 'Nie',
    'kiosk.welcome.tap': 'Dotknij tutaj, aby się zarejestrować lub wymeldować',
    'kiosk.welcome.offline': 'Tryb offline: rejestracje są zapisywane i wysyłane później',
    'kiosk.home.title': 'Co Państwo chcą zrobić?',
    'kiosk.home.signIn': 'Zarejestruj wejście',
    'kiosk.home.signOut': 'Zarejestruj wyjście',
    'kiosk.home.scan': 'Zeskanuj mój identyfikator',
    'kiosk.groups.titleIn': 'W jakiej roli się Państwo rejestrują?',
    'kiosk.groups.titleOut': 'W jakiej roli się Państwo wymeldowują?',
    'kiosk.groups.hint': 'Wybierz opcję, która najlepiej do Państwa pasuje.',
    'kiosk.groups.repeat': 'Stali członkowie',
    'kiosk.pin.hint': 'Wpisz czterocyfrowy kod PIN.',
    'kiosk.pin.entered': 'Wpisano {count} z 4 cyfr',
    'kiosk.pin.wrong': 'Ten kod PIN jest nieprawidłowy. Spróbuj ponownie.',
    'kiosk.pin.locked': 'Zbyt wiele błędnych kodów PIN. Wpisywanie kodu jest zablokowane na kilka minut. Poproś kogoś o pomoc.',
    'kiosk.pin.clear': 'Wyczyść',
    'kiosk.pin.back': 'Usuń ostatnią cyfrę',
    'kiosk.identify.title': 'Proszę wyszukać swoje imię i nazwisko',
    'kiosk.identify.placeholder': 'Zacznij wpisywać imię i nazwisko',
    'kiosk.identify.none': 'Nie znaleziono nikogo o tym nazwisku.',
    'kiosk.identify.addSelf': 'Nie ma mnie na liście',
    'kiosk.addSelf.title': 'Dodaj siebie',
    'kiosk.name.title': 'Jak się Pan/Pani nazywa?',
    'kiosk.name.label': 'Imię i nazwisko',
    'kiosk.name.fullNameHint': 'Proszę podać imię i nazwisko.',
    'kiosk.already.message': 'Wejście jest już zarejestrowane. Czy zamiast tego zarejestrować wyjście?',
    'kiosk.already.signOut': 'Zarejestruj wyjście',
    'kiosk.questions.titleIn': 'Kilka krótkich pytań',
    'kiosk.questions.titleOut': 'Zanim Państwo wyjdą',
    'kiosk.questions.datePlaceholder': 'YYYY-MM-DD',
    'kiosk.questions.acknowledge': 'Rozumiem',
    'kiosk.questions.hostSearch': 'Wpisz nazwisko osoby, do której Państwo przychodzą',
    'kiosk.questions.changeHost': 'Zmień',
    'kiosk.notices.progress': 'Informacja {n} z {total}',
    'kiosk.notices.accept': 'Zapoznano się i akceptuję',
    'kiosk.notices.sign': 'Podpisz',
    'kiosk.notices.signHere': 'Proszę podpisać palcem.',
    'kiosk.signature.pad': 'Pole podpisu',
    'kiosk.signature.clear': 'Wyczyść podpis',
    'kiosk.signature.captured': 'Podpis zapisany',
    'kiosk.photo.title': 'Zdjęcie',
    'kiosk.photo.hint': 'Spójrz w kamerę i dotknij przycisku.',
    'kiosk.photo.take': 'Zrób zdjęcie',
    'kiosk.photo.getReady': 'Przygotuj się…',
    'kiosk.photo.retake': 'Zrób ponownie',
    'kiosk.photo.use': 'Użyj tego zdjęcia',
    'kiosk.photo.skip': 'Pomiń zdjęcie',
    'kiosk.photo.failed': 'Zdjęcie nie zostało zrobione. Spróbuj ponownie.',
    'kiosk.photo.noCamera': 'Kamera jest niedostępna. Można kontynuować bez zdjęcia.',
    'kiosk.photo.privacy': 'Zdjęcie jest używane tylko do identyfikatora i karty wizyty.',
    'kiosk.badge.title': 'Identyfikator',
    'kiosk.badge.ask': 'Czy potrzebny jest identyfikator?',
    'kiosk.badge.yes': 'Wydrukuj identyfikator',
    'kiosk.badge.no': 'Nie, dziękuję',
    'kiosk.badge.printing': 'Drukowanie identyfikatora…',
    'kiosk.badge.done': 'Proszę odebrać identyfikator',
    'kiosk.badge.failed': 'Przepraszamy, identyfikator nie został wydrukowany. Wejście jest zarejestrowane. Proszę poprosić o identyfikator w recepcji.',
    'kiosk.signout.title': 'Wyszukaj swoje nazwisko, aby się wymeldować',
    'kiosk.signout.search': 'Szukaj po nazwisku',
    'kiosk.signout.hiddenHint': 'Ze względu na prywatność nazwiska nie są wyświetlane. Wpisz nazwisko lub zeskanuj identyfikator.',
    'kiosk.signout.empty': 'Nikt nie jest zarejestrowany.',
    'kiosk.signout.noMatch': 'Nie znaleziono nikogo. Spróbuj ponownie lub zeskanuj identyfikator.',
    'kiosk.signout.unnamed': 'Gość',
    'kiosk.scan.title': 'Zeskanuj identyfikator',
    'kiosk.scan.hint': 'Trzymaj kod QR z identyfikatora przed kamerą.',
    'kiosk.scan.allow': 'Zezwól na kamerę',
    'kiosk.scan.noCamera': 'Kamera jest niedostępna. Wybierz nazwisko z listy.',
    'kiosk.scan.notBadge': 'To nie jest identyfikator CloudSign. Spróbuj ponownie.',
    'kiosk.scan.notSignedIn': 'Ten identyfikator nie jest tu zarejestrowany. Wybierz nazwisko z listy.',
    'kiosk.finish.inTitle': 'Dziękujemy, {name}',
    'kiosk.finish.inMessage': 'Wejście zostało zarejestrowane.',
    'kiosk.finish.outTitle': 'Do widzenia, {name}',
    'kiosk.finish.outMessage': 'Wyjście zostało zarejestrowane. Szerokiej drogi!',
    'kiosk.finish.tap': 'Dotknij, aby zakończyć',
    'kiosk.update.title': 'Ten kiosk wymaga aktualizacji',
    'kiosk.update.message': 'Ten kiosk wymaga aktualizacji, zanim będzie mógł zarejestrować wejście. Proszę zapytać w recepcji.',
    'kiosk.update.short': 'Wymaga aktualizacji',
    'kiosk.error.required': 'Proszę odpowiedzieć na to pytanie.',
    'kiosk.error.mustAcknowledge': 'Proszę zaznaczyć, aby potwierdzić.',
    'kiosk.error.nameRequired': 'Proszę wpisać imię i nazwisko.',
    'kiosk.error.fullName': 'Proszę podać imię i nazwisko.',
    'kiosk.error.tooLong': 'Ta odpowiedź jest za długa.',
    'kiosk.error.number': 'Proszę wpisać liczbę.',
    'kiosk.error.wholeNumber': 'Proszę wpisać liczbę całkowitą.',
    'kiosk.error.range': 'Ta liczba jest poza dozwolonym zakresem.',
    'kiosk.error.email': 'Proszę podać prawidłowy adres e-mail.',
    'kiosk.error.phone': 'Proszę podać prawidłowy numer telefonu.',
    'kiosk.error.date': 'Proszę podać datę w formacie 2026-12-31.',
    'kiosk.error.answerNotAllowed': 'Ta odpowiedź oznacza, że nie można się tutaj zarejestrować. Proszę porozmawiać z recepcją.',
    'kiosk.print.state.ready': 'Drukarka jest gotowa',
    'kiosk.print.state.no_media': 'Drukarce skończyły się etykiety',
    'kiosk.print.state.cover_open': 'Pokrywa drukarki jest otwarta',
    'kiosk.print.state.media_mismatch': 'W drukarce są niewłaściwe etykiety',
    'kiosk.print.state.busy': 'Drukarka jest zajęta',
    'kiosk.print.state.error': 'Drukarka zgłasza problem',
    'kiosk.print.state.unreachable': 'Nie można połączyć się z drukarką',
    'kiosk.print.state.unknown': 'Stan drukarki jest nieznany',
    'kiosk.home.expected': 'Mam umówioną wizytę',
    'kiosk.home.scanCode': 'Zeskanuj mój kod QR',
    'kiosk.scan.titleCode': 'Zeskanuj kod QR',
    'kiosk.scan.hintCode': 'Trzymaj przed kamerą kod QR z wiadomości e-mail, karty lub identyfikatora.',
    'kiosk.scan.invalid': 'Ten kod QR jest tutaj nieprawidłowy. Spróbuj ponownie lub wybierz nazwisko z listy.',
    'kiosk.scan.notSupported': 'Ten kiosk nie obsługuje tego rodzaju kodu QR. Wybierz nazwisko z listy.',
    'kiosk.scan.unknownMember': 'Ten kod QR nie jest rozpoznawany w tym kiosku. Wybierz nazwisko z listy.',
    'kiosk.scan.oldCode': 'Ten kod QR został zastąpiony nowym. Użyj najnowszego lub wybierz nazwisko.',
    'kiosk.scan.notHere': 'Ten kod QR nie dotyczy tego kiosku.',
    'kiosk.scan.notExpected': 'Dziś nie spodziewamy się tej osoby. Proszę zapytać w recepcji.',
    'kiosk.scan.cancelled': 'Ta wizyta została odwołana. Proszę zapytać w recepcji.',
    'kiosk.scan.alreadyArrived': 'Ten kod QR został już użyty do zarejestrowania wejścia.',
    'kiosk.scan.expired': 'Ten kod QR wygasł. Proszę zapytać w recepcji.',
    'kiosk.expected.title': 'Kim Pan/Pani jest?',
    'kiosk.expected.search': 'Zacznij wpisywać imię i nazwisko',
    'kiosk.expected.exactHint': 'Proszę wpisać pełne imię i nazwisko dokładnie tak, jak je podano.',
    'kiosk.expected.requiredHint': 'Aby się tutaj zarejestrować, trzeba być oczekiwanym. Znajdź swoje nazwisko lub zeskanuj kod QR.',
    'kiosk.expected.none': 'Nie znaleźliśmy tego nazwiska na dzisiejszej liście. Proszę zapytać w recepcji.',
    'kiosk.expected.empty': 'Obecnie nikt nie jest oczekiwany.',
    'kiosk.expected.visiting': 'Wizyta u: {host}',
    'kiosk.expected.required': 'Aby się tutaj zarejestrować, trzeba być oczekiwanym. Proszę zapytać w recepcji.',
    'kiosk.signout.outMark': 'Wyjście',
    'kiosk.signout.outToday': 'Wyjście zarejestrowane dziś',
    'kiosk.hostReply.on_my_way': '{host} jest w drodze.',
    'kiosk.hostReply.please_wait': '{host} prosi o chwilę cierpliwości.',
    'kiosk.hostReply.someone': 'Osoba przyjmująca',
    'kiosk.hostReply.dismiss': 'OK',
    'kiosk.evacuation.notAllowed': 'Z tego kiosku nie można rozpocząć ewakuacji.',
    'kiosk.evacuation.wrongPin': 'Ten kod PIN jest nieprawidłowy.',
    'kiosk.evacuation.pinLocked': 'Zbyt wiele błędnych kodów PIN. Proszę odczekać kilka minut.',
    'kiosk.evacuation.startFailed': 'Nie udało się rozpocząć ewakuacji. Spróbuj ponownie.',
    'kiosk.nfc.enrolOffline': 'Ten kiosk jest offline. Karty można rejestrować tylko wtedy, gdy kiosk ma połączenie.',
    'kiosk.nfc.enrolExpired': 'Rejestracja karty została zakończona lub upłynął na nią czas.',
    'kiosk.nfc.enrolFailed': 'Tej karty nie można zarejestrować. Proszę spróbować innej.',
    'kiosk.nfc.enrolTapAgain': 'Proszę ponownie przyłożyć kartę.',
    'kiosk.common.ok': 'OK',
    'kiosk.welcome.stale': 'Ten kiosk był długo offline. Proszę poinformować recepcję.',
    'kiosk.welcome.busy': 'Obecnie na terenie jest tłoczno. Jeśli przychodzą Państwo w odwiedziny, proszę poinformować recepcję.',
    'kiosk.welcome.evacuation': 'Ewakuacja',
    'kiosk.home.delivery': 'Dostarczam przesyłkę',
    'kiosk.check.seeReceptionTitle': 'Proszę zgłosić się do recepcji',
    'kiosk.check.warnTitle': 'Przed kontynuowaniem',
    'kiosk.full.short': 'Obiekt jest pełny',
    'kiosk.full.title': 'Obiekt jest pełny',
    'kiosk.full.message': 'Obecnie nie możemy zarejestrować kolejnych gości. Proszę zgłosić się do recepcji.',
    'kiosk.induction.subtitle': 'Szkolenie wstępne BHP',
    'kiosk.induction.unavailable': 'Szkolenie wstępne nie jest dostępne na tym kiosku. Proszę zgłosić się do recepcji.',
    'kiosk.induction.videoMissing': 'Film nie jest jeszcze dostępny na tym kiosku. Proszę przeczytać tekst poniżej.',
    'kiosk.induction.pdfNote': 'Proszę przeczytać tekst szkolenia poniżej. Jeśli chcą Państwo otrzymać dokument, proszę zapytać w recepcji.',
    'kiosk.induction.wait': 'Proszę czekać {seconds} sekund',
    'kiosk.induction.startQuiz': 'Rozpocznij pytania',
    'kiosk.induction.question': 'Pytanie {n} z {total}',
    'kiosk.induction.chooseMany': 'Proszę wybrać wszystkie poprawne odpowiedzi.',
    'kiosk.induction.finish': 'Zakończ',
    'kiosk.induction.retryTitle': 'Jeszcze nie w porządku',
    'kiosk.induction.retryMessage': 'Niektóre odpowiedzi były błędne. Proszę spróbować ponownie: {count}.',
    'kiosk.induction.retryButton': 'Spróbuj ponownie',
    'kiosk.permits.title': 'Zezwolenia na pracę',
    'kiosk.permits.unavailable': 'Zezwoleń nie można teraz wyświetlić. Przed rozpoczęciem pracy proszę zgłosić się do recepcji.',
    'kiosk.permits.allAccepted': 'Zaakceptowano wszystkie zezwolenia.',
    'kiosk.permits.progress': 'Zezwolenie {n} z {total}',
    'kiosk.permits.valid': 'Od {from} do {until}',
    'kiosk.permits.conditions': 'Warunki',
    'kiosk.permits.precautions': 'Środki ostrożności',
    'kiosk.permits.signHere': 'Proszę podpisać tutaj, aby zaakceptować, {name}',
    'kiosk.permits.accept': 'Akceptuję to zezwolenie',
    'kiosk.nfc.blocked': 'Ta karta została zablokowana',
    'kiosk.nfc.unknown': 'Nie rozpoznano karty',
    'kiosk.nfc.enrolTitle': 'Rejestracja kart',
    'kiosk.nfc.enrolProgress': 'Zakończono {done} z {total}',
    'kiosk.nfc.enrolTapFor': 'Przyłóż kartę dla',
    'kiosk.nfc.enrolHold': 'Przyłóż kartę do tyłu tabletu.',
    'kiosk.nfc.enrolSaving': 'Zapisywanie…',
    'kiosk.nfc.enrolOk': 'Karta zapisana.',
    'kiosk.nfc.enrolDone': 'Wszystkie karty zostały zarejestrowane',
    'kiosk.nfc.noReader': 'Na tym kiosku nie włączono czytnika kart.',
    'kiosk.evacuation.title': 'EWAKUACJA',
    'kiosk.evacuation.drillTitle': 'ĆWICZENIA POŻAROWE',
    'kiosk.evacuation.startTitle': 'Rozpocznij ewakuację',
    'kiosk.evacuation.confirmTitle': 'Rozpocząć ewakuację?',
    'kiosk.evacuation.confirmMessage': 'Powiadomi to wszystkie osoby na terenie i otworzy listę obecności.',
    'kiosk.evacuation.confirmStart': 'Rozpocznij ewakuację',
    'kiosk.evacuation.leave': 'Opuść listę obecności',
    'kiosk.evacuation.leaveTitle': 'Wpisz kod PIN, aby opuścić listę obecności',
    'kiosk.evacuation.returnBanner': 'Trwa ewakuacja. Dotknij, aby wrócić do listy obecności.',
    'kiosk.evacuation.offline': 'Tryb offline: oznaczenia są zapisywane i zostaną wysłane po przywróceniu połączenia.',
    'kiosk.evacuation.localOnly': 'Uruchomiono na tym kiosku w trybie offline. Zostanie połączona z portalem po przywróceniu połączenia.',
    'kiosk.evacuation.countUnaccounted': 'Jeszcze nie znaleziono',
    'kiosk.evacuation.countSafe': 'Bezpieczni',
    'kiosk.evacuation.countMissing': 'Zaginieni',
    'kiosk.evacuation.countTotal': 'Na terenie',
    'kiosk.evacuation.allPoints': 'Wszyscy',
    'kiosk.evacuation.search': 'Szukaj po nazwisku',
    'kiosk.evacuation.onlyOpen': 'Jeszcze nie bezpieczni',
    'kiosk.evacuation.loading': 'Ładowanie listy obecności…',
    'kiosk.evacuation.nobody': 'Brak osób do wyświetlenia.',
    'kiosk.evacuation.safe': 'Bezpieczny',
    'kiosk.evacuation.markedSafe': 'BEZPIECZNY (dotknij, aby cofnąć)',
    'kiosk.evacuation.missing': 'Zaginiony',
    'kiosk.evacuation.markedMissing': 'ZAGINIONY (dotknij, aby cofnąć)',
    'kiosk.evacuation.host': 'Osoba przyjmująca: {name}',
    'kiosk.evacuation.check': 'SPRAWDŹ',
    'kiosk.evacuation.permits': 'Otwarte zezwolenia: {count}',
    'kiosk.contactless.qrLabel': 'Zeskanuj ten kod telefonem, aby się zarejestrować',
    'kiosk.contactless.scanMe': 'Zarejestruj się telefonem',
    'kiosk.courier.whoTitle': 'Dla kogo jest przesyłka?',
    'kiosk.courier.whoHint': 'Wpisz kilka liter z nazwiska.',
    'kiosk.courier.search': 'Nazwisko odbiorcy',
    'kiosk.courier.useName': 'Użyj „{name}”',
    'kiosk.courier.useNameHint': 'Recepcja przekaże przesyłkę',
    'kiosk.courier.carrierTitle': 'Z jakiej firmy Państwo przyjeżdżają?',
    'kiosk.courier.forName': 'Przesyłka dla: {name}',
    'kiosk.courier.other': 'Inna',
    'kiosk.courier.otherLabel': 'Nazwa firmy',
    'kiosk.courier.countTitle': 'Ile jest przesyłek?',
    'kiosk.courier.howMany': 'Liczba przesyłek',
    'kiosk.courier.save': 'Gotowe',
    'kiosk.courier.thanks': 'Dziękujemy',
    'kiosk.courier.thanksMessage': 'Powiadomiliśmy odbiorcę, że przesyłka już jest.',
    'kiosk.support.pinTitle': 'Pomoc techniczna: wpisz kod PIN',
    'kiosk.support.title': 'Pomoc techniczna',
    'kiosk.support.close': 'Zamknij',
    'kiosk.support.network': 'Sieć',
    'kiosk.support.online': 'Online',
    'kiosk.support.offline': 'Offline',
    'kiosk.support.queue': 'Oczekuje na wysłanie',
    'kiosk.support.oldest': 'Najdłużej czeka od',
    'kiosk.support.none': 'Brak',
    'kiosk.support.deadLetters': 'Odrzucone przez serwer (nie wysłane)',
    'kiosk.support.deadHelp': 'Te pozycje zostały odrzucone przez serwer i pozostają na tym kiosku. Poinformuj administratora; strona urządzenia w portalu pokazuje ich liczbę.',
    'kiosk.support.configAge': 'Ustawienia zaktualizowano',
    'kiosk.support.ageUnknown': 'Nigdy',
    'kiosk.support.ageMinutes': '{n} min temu',
    'kiosk.support.ageHours': '{n} godz. temu',
    'kiosk.support.ageDays': '{n} dni temu',
    'kiosk.support.nfc': 'Czytnik kart',
    'kiosk.support.nfcReady': 'Gotowy',
    'kiosk.support.nfcOff': 'Wyłączony',
    'kiosk.support.nfcNone': 'Brak',
    'kiosk.support.media': 'Zapisane filmy',
    'kiosk.support.mediaMb': '{mb} MB',
    'kiosk.support.headcount': 'Osoby na terenie (ten kiosk)',
    'kiosk.finish.poweredBy': 'Zasilane przez CloudSign',
    'kiosk.badge.noMedia': 'W drukarce identyfikatorów skończyły się etykiety. Wejście jest zarejestrowane. Proszę powiadomić recepcję.',
    'kiosk.badge.mediaMismatch': 'W drukarce identyfikatorów załadowano niewłaściwe etykiety. Wejście jest zarejestrowane. Proszę powiadomić recepcję.',
    'kiosk.badge.coverOpen': 'Pokrywa drukarki identyfikatorów jest otwarta. Wejście jest zarejestrowane. Proszę powiadomić recepcję.',
    'kiosk.member.menuTitle': 'Co Państwo chcą zrobić?',
    'kiosk.member.signIn': 'Zarejestruj mnie',
    'kiosk.member.updatePhoto': 'Zaktualizuj moje zdjęcie',
    'kiosk.member.sendInvite': 'Wyślij mi zaproszenie do aplikacji',
    'kiosk.memberPhoto.title': 'Zaktualizuj zdjęcie',
    'kiosk.memberPhoto.saved': 'Zdjęcie zostało zaktualizowane.',
    'kiosk.memberPhoto.failed': 'Nie udało się zapisać zdjęcia. Spróbuj ponownie lub zapytaj w recepcji.',
    'kiosk.memberPhoto.offline': 'Ten kiosk jest offline, więc zdjęcie nie może być teraz zaktualizowane.',
    'kiosk.memberPhoto.notAllowed': 'Zdjęcie nie może być zaktualizowane na kiosku. Proszę zapytać w recepcji.',
    'kiosk.invite.title': 'Pobierz aplikację CloudSign',
    'kiosk.invite.sent': 'Wysłaliśmy e-mailem link do konfiguracji aplikacji. Sprawdź skrzynkę odbiorczą.',
    'kiosk.invite.noEmail': 'Nie mamy Pana/Pani adresu e-mail, więc nie mogliśmy wysłać zaproszenia. Proszę zapytać w recepcji.',
    'kiosk.invite.tooMany': 'Dziś zażądano zbyt wielu zaproszeń. Spróbuj ponownie jutro.',
    'kiosk.invite.failed': 'Nie udało się wysłać zaproszenia. Spróbuj ponownie lub zapytaj w recepcji.',
    'kiosk.invite.offline': 'Ten kiosk jest offline, więc zaproszenie nie może być teraz wysłane.',
    'kiosk.invite.sending': 'Wysyłanie zaproszenia…',
    'kiosk.language.choose': 'Wybierz język',
    'kiosk.language.button': 'Język',
    'public.language.label': 'Język',
    'contactless.thank_you': 'Dziękujemy. Wejście zostało zarejestrowane.',
    'contactless.thank_you_out': 'Dziękujemy. Wyjście zostało zarejestrowane.',
    'contactless.poster.title': 'Zeskanuj, aby się zarejestrować',
    'contactless.poster.hint': 'Skieruj aparat telefonu na kod. Aplikacja nie jest potrzebna.',
    'check.safety_check.refused': 'Przed rejestracją proszę zgłosić się do recepcji.',
    'check.safety_check.alert': 'Wpuszczono z powiadomieniem dla recepcji (kontrola bezpieczeństwa).',
    'check.compliance.refused': 'Brakuje wymaganego dokumentu lub minął jego termin ważności. Proszę zgłosić się do recepcji.',
    'check.compliance.warned': 'Brakuje wymaganego dokumentu lub minął jego termin ważności.',
    'check.induction.required': 'Proszę najpierw odbyć szkolenie wstępne na terenie obiektu.',
    'check.capacity.full': 'Obiekt jest obecnie pełny. Proszę zgłosić się do recepcji.',
    'check.capacity.warned': 'Zarejestrowano, gdy obiekt przekroczył pojemność.',
    'check.offline': 'Zapisano, gdy kiosk był offline.',
};
//# sourceMappingURL=pl.js.map